/**
 * Shared left/right send panel — used by Publish and Broadcast Solution overlays.
 */
var _require = require('./overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
function buildSendPanelOverlay(_ref) {
  var _ref$extraRootClass = _ref.extraRootClass,
    extraRootClass = _ref$extraRootClass === void 0 ? '' : _ref$extraRootClass,
    _ref$scriptDisplay = _ref.scriptDisplay,
    scriptDisplay = _ref$scriptDisplay === void 0 ? '' : _ref$scriptDisplay,
    _ref$leftPanelHtml = _ref.leftPanelHtml,
    leftPanelHtml = _ref$leftPanelHtml === void 0 ? '' : _ref$leftPanelHtml,
    _ref$leftColumnClass = _ref.leftColumnClass,
    leftColumnClass = _ref$leftColumnClass === void 0 ? 'rs-publish-send-script' : _ref$leftColumnClass,
    formFieldsHtml = _ref.formFieldsHtml,
    _ref$errorExtraClass = _ref.errorExtraClass,
    errorExtraClass = _ref$errorExtraClass === void 0 ? '' : _ref$errorExtraClass,
    actionButtonHtml = _ref.actionButtonHtml;
  var leftContent = leftPanelHtml ? leftPanelHtml : "<pre class=\"rs-publish-script-readonly\" spellcheck=\"false\">".concat(scriptDisplay, "</pre>");
  var bodyHtml = "\n    <div class=\"rs-publish-send-panels\">\n      <div class=\"rs-publish-send-column ".concat(leftColumnClass, "\">\n        ").concat(leftContent, "\n      </div>\n      <div class=\"rs-publish-send-column rs-publish-send-form\">\n        ").concat(formFieldsHtml, "\n        <p class=\"rs-publish-error ").concat(errorExtraClass, "\" hidden></p>\n        ").concat(actionButtonHtml ? "<div class=\"rs-overlay-actions rs-overlay-actions-end\">\n          ".concat(actionButtonHtml, "\n        </div>") : '', "\n      </div>\n    </div>\n  ");
  return buildRustscriptOverlay({
    className: "rs-overlay-workspace rs-publish-send ".concat(extraRootClass),
    bodyHtml: bodyHtml
  });
}
module.exports = {
  buildSendPanelOverlay: buildSendPanelOverlay
};